import sceneEdit from './scene-edit.module'
export default sceneEdit
